import { render, staticRenderFns } from "./PdfFieldCanvas.vue?vue&type=template&id=13dd629b&scoped=true&"
import script from "./PdfFieldCanvas.vue?vue&type=script&lang=ts&"
export * from "./PdfFieldCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./PdfFieldCanvas.vue?vue&type=style&index=0&id=13dd629b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd629b",
  null
  
)

export default component.exports